// extracted by mini-css-extract-plugin
module.exports = {"item":"ComposeTagsSuggests__item__5lzYt","active":"ComposeTagsSuggests__active__hsadm","count":"ComposeTagsSuggests__count__xtosj"};